@if (fieldSet(); as fieldSet) {
  @let preview = ublPreview();
  @let documentType =
    isTaxDocument()
      ? ('PEPPOL.FILTERS.DOCUMENT_TYPE.TaxDocument' | translate) + ':'
      : '';

  <header class="wf-peppol-ubl-preview__header">
    <h2 class="wf-peppol-ubl-preview__title">
      {{ documentType }} {{ preview.number ?? '' }}
    </h2>
  </header>

  <div class="wf-peppol-ubl-preview__body">
    @if (parties().length) {
      <section class="wf-peppol-ubl-preview__parties">
        @for (party of parties(); track party.heading) {
          <div
            class="wf-peppol-ubl-preview__party"
            [class.wf-peppol-ubl-preview__party--bordered]="party.bordered"
          >
            <h3 class="wf-peppol-ubl-preview__party-heading">
              {{ party.heading | translate }}
            </h3>
            @if (party.name) {
              <span class="wf-peppol-ubl-preview__party-name">
                {{ party.name }}
              </span>
            }
            <div class="wf-peppol-ubl-preview__party-fields">
              @for (row of party.rows; track row.key) {
                @if (row.value) {
                  <span>
                    @if (row.noLabel) {
                      {{ row.value }}
                    } @else {
                      {{ row.key | translate }}: {{ row.value }}
                    }
                  </span>
                }
              }
            </div>
          </div>
        }
      </section>
    }

    @if (paymentEntries().length || dateEntries().length) {
      <section class="wf-peppol-ubl-preview__meta">
        @if (paymentEntries().length) {
          <dl class="wf-peppol-ubl-preview__pairs">
            @for (entry of paymentEntries(); track entry.key) {
              <div class="wf-peppol-ubl-preview__pair">
                <dt>{{ entry.key | translate }}:</dt>
                <dd>{{ entry.value }}</dd>
              </div>
            }
          </dl>
        }
        @if (dateEntries().length) {
          <dl class="wf-peppol-ubl-preview__pairs">
            @for (entry of dateEntries(); track entry.key) {
              <div class="wf-peppol-ubl-preview__pair">
                <dt>{{ entry.key | translate }}:</dt>
                <dd>
                  @switch (entry.type) {
                    @case ('date') {
                      {{ entry.value | date: 'dd.MM.yyyy' }}
                    }
                    @default {
                      {{ entry.value }}
                    }
                  }
                </dd>
              </div>
            }
          </dl>
        }
      </section>
    }

    @if (fieldSet.showLines && preview.lines?.length) {
      <wf-peppol-ubl-preview-lines [lines]="preview.lines ?? []" />
    }

    @if (fieldSet.showVatRecap && preview.vaTs?.length) {
      <wf-peppol-ubl-preview-vat-recap
        class="wf-peppol-ubl-preview__vat"
        [vats]="preview.vaTs ?? []"
      />
    }
  </div>

  @if (fieldSet.showTotal && preview.totalAmount != null) {
    <footer class="wf-peppol-ubl-preview__footer">
      <span class="wf-peppol-ubl-preview__footer-label">
        {{ 'PEPPOL.Preview.PayableAmount' | translate }}:
      </span>
      <span class="wf-peppol-ubl-preview__footer-value">
        {{ preview.totalAmount | number: '1.2-2' }} {{ preview.currency }}
      </span>
    </footer>
  }
}
